var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"account-tap"},[_c('Search',{staticClass:"w-100 p-0",on:{"search":_vm.getData}}),_vm._v(" "),_c('b-overlay',{attrs:{"show":_vm.apiLoading,"rounded":"sm","spinner-variant":"primary"}},[_c('div',{staticClass:"list"},_vm._l((_vm.list),function(item,index){return _c('Card',{key:index,attrs:{"data":item}})}),1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }